import { BlockerTextContainer, BlockerHeroContainer, useBlocker } from "../..";

const Blocker = () => {
  const blocker = useBlocker();
  const {
    blocker: {
      visualType,
      visualThumbnail
    }
  } = blocker;

  if (process.env.PLUGIN_CTX === "pro") {
    /* onlypro:start */
    return visualType === "hero" && visualThumbnail ? h(BlockerHeroContainer, null) : h(BlockerTextContainer, null);
    /* onlypro:end */
  } else {
    return h(BlockerTextContainer, null);
  }
};

export { Blocker };